import React, { Component } from "react";

export class CustomSelect extends Component {
  constructor(props) {
    super(props);
    this.state = {
        selectedValue: ""
    };
    this.handleSelectChange = this.handleSelectChange.bind(this);
  }

  handleSelectChange(event) {
    this.setState({ selectedValue: event.target.value });
    this.props.handleSelectChange(event);
  }

  render() {
    const { optionTypes, userType, selectedValue: propSelectedValue } = this.props;
    const selectedValue = propSelectedValue !== undefined ? propSelectedValue : this.state.selectedValue;

    const renderOptionsJSX = Object.keys(optionTypes).map((key) => {
      if (key === "sendKudosAsAdmin" && userType == 2) {
        return null;
      }
      return (
        <option key={key} value={key}>
          {optionTypes[key]}
        </option>
      );
    });

    return (
      <select
        className="form-control mb-8"
        value={selectedValue}
        onChange={this.handleSelectChange}
      >
        <option value="" disabled hidden>Make a choice ...</option>
        {renderOptionsJSX}
      </select>
    );
  }
}
